import type { SVGProps } from "react";

export const Factorial = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    style={{}}
    version="1.1"
    viewBox="0 0 42 42"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    y="0px"
    {...props}
  >
    <title>Factorial</title>

    <g>
      <g>
        <path
          d="M34.2,37.3c-3.7,3-8.4,4.7-13.2,4.7c-4.8,0-9.5-1.6-13.2-4.7c3.7-3,8.4-4.7,13.2-4.7
			C26,32.6,30.6,34.4,34.2,37.3L34.2,37.3z M34.2,37.3"
          style={{ fill: "#FF355E" }}
        />
        <path
          d="M7.7,32.2C5,29.1,3.5,25.1,3.6,21c0-9.6,7.8-17.4,17.4-17.4c9.6,0,17.4,7.8,17.4,17.4c0,4.3-1.5,8.2-4.1,11.2
			c0.9,0.6,1.7,1.2,2.5,1.8l0.3,0.3C40.3,30.6,42,25.9,42,21C42,9.4,32.6,0,21,0S0,9.4,0,21c0,4.9,1.7,9.6,4.8,13.3l0.3-0.3
			C5.9,33.4,6.8,32.8,7.7,32.2L7.7,32.2z M7.7,32.2"
          style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#FF355E" }}
        />
      </g>
      <path
        d="M28.8,20.4c0,4.3-3.5,7.8-7.8,7.8s-7.8-3.5-7.8-7.8c0-4.3,3.5-7.8,7.8-7.8S28.8,16.1,28.8,20.4L28.8,20.4z"
        style={{ fill: "#FF355E" }}
      />
    </g>
  </svg>
);

export default Factorial;
